import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { stockApi, type StockAdjustmentRequest } from "@/lib/admin-api/stock";

export function useStockAdjustment(productId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: StockAdjustmentRequest) =>
      stockApi.adjust(productId, body),

    onSuccess: (data) => {
      // Invalidate product list and stock history caches
      void queryClient.invalidateQueries({ queryKey: ["admin", "products"] });
      void queryClient.invalidateQueries({
        queryKey: ["admin", "stock-history", productId],
      });
      toast.success(
        `Stock mis a jour : ${data.previous_stock} → ${data.new_stock} (${data.delta > 0 ? "+" : ""}${data.delta})`,
      );
    },

    onError: (error: unknown) => {
      // 409 = version conflict, handled by caller via ConflictResolutionDialog
      if (error instanceof Error && error.message.includes("409")) {
        return; // Caller handles conflict
      }
      const message =
        error instanceof Error
          ? error.message
          : "Erreur lors de l'ajustement du stock";
      toast.error(message);
    },
  });
}
